"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysRange = void 0;
var TileDataContext_1 = require("../components/TileDataContext");
var formatDateAndMonth_1 = __importDefault(require("../utils/formatDateAndMonth"));
var DaysRange;
(function (DaysRange) {
    DaysRange[DaysRange["SameDayDelivery"] = 0] = "SameDayDelivery";
    DaysRange[DaysRange["UnderFourDays"] = 1] = "UnderFourDays";
    DaysRange[DaysRange["Tomorrow"] = 2] = "Tomorrow";
    DaysRange[DaysRange["OverFourDays"] = 3] = "OverFourDays";
    DaysRange[DaysRange["Unknown"] = 4] = "Unknown";
})(DaysRange || (exports.DaysRange = DaysRange = {}));
function getDaysRange(daysUntilDeliveryOrPickup) {
    if (daysUntilDeliveryOrPickup < 1)
        return DaysRange.SameDayDelivery;
    if (daysUntilDeliveryOrPickup === 1)
        return DaysRange.Tomorrow;
    if (daysUntilDeliveryOrPickup > 1 && daysUntilDeliveryOrPickup <= 4)
        return DaysRange.UnderFourDays;
    if (daysUntilDeliveryOrPickup > 4)
        return DaysRange.OverFourDays;
    return DaysRange.Unknown;
}
function useGetItBy() {
    var _a;
    var _b;
    var _c = (0, TileDataContext_1.useTileDataContext)().soonestAvailabilityInfo, _d = _c.activityType, activityType = _d === void 0 ? '' : _d, utcSoonestDateTimeIso = _c.utcSoonestDateTimeIso, asSoonAsText = _c.asSoonAsText, daysToAvailability = _c.daysToAvailability, _e = _c.routeId, routeId = _e === void 0 ? '' : _e;
    if (!utcSoonestDateTimeIso || daysToAvailability === undefined)
        return {
            activityType: '',
            utcSoonestDateTimeIso: '',
            getItBy: '',
            routeId: ''
        };
    var chipTextMap = (_a = {},
        _a[DaysRange.SameDayDelivery] = 'Today',
        _a[DaysRange.UnderFourDays] = asSoonAsText,
        _a[DaysRange.Tomorrow] = 'Tomorrow',
        _a[DaysRange.OverFourDays] = (0, formatDateAndMonth_1.default)(utcSoonestDateTimeIso),
        _a[DaysRange.Unknown] = '',
        _a);
    return {
        activityType: activityType,
        utcSoonestDateTimeIso: utcSoonestDateTimeIso,
        getItBy: (_b = chipTextMap[getDaysRange(daysToAvailability)]) !== null && _b !== void 0 ? _b : '',
        routeId: routeId
    };
}
exports.default = useGetItBy;
//# sourceMappingURL=useGetItBy.js.map